import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { requireSignIn } from '../auth/gate';
import { HushedFrame } from '../screens/auth/HushedFrame';
import { ConnectPage } from '../screens/device/ConnectPage';
import { connectRequest } from '../screens/device/connect-words';

/** A value from the link as text; the router reads a value that looks like a number as one. */
const text = z.union([z.string(), z.number()]).transform(String).optional().catch(undefined);

const searchSchema = z.object({
  challenge: text,
  redirect_uri: text,
  state: text,
  name: text,
  model: text,
});

/**
 * Connect this computer (docs/engineering/folder-monitor.md, sections 3 and 7): Paige Scan opens it
 * with a PKCE challenge and its loopback callback. Signed in as everywhere else, on the sign-in pages'
 * ground, outside any one company because the person's companies decide what happens. Not under
 * `/device`: the copiers' code page stays as it is.
 */
export const Route = createFileRoute('/device_/connect')({
  validateSearch: searchSchema,
  beforeLoad: async ({ context, location }) => {
    await requireSignIn(context.auth, location.href);
  },
  component: RouteComponent,
});

function RouteComponent() {
  const search = Route.useSearch();
  return (
    <HushedFrame>
      <ConnectPage request={connectRequest(search)} />
    </HushedFrame>
  );
}
